import { LoadingOutlined } from "@ant-design/icons";
import { useMutation, useQuery } from "@tanstack/react-query";
import { Alert, Form, Spin, TreeSelect, message } from "antd";
import React, { useEffect, useState } from "react";
import {
  assignClient,
  backendEntryAssignClient,
  getAssignClientList,
  getProjectId,
  getProjectInfoById,
  updateAssignClient,
} from "../../../../api/apiCallManager";
import AccessTo from "../../../../components/is-show/AccessTo";
import { isCurrentRoleReadOnly } from "../../../../helpers/authFunctions";
import { CM, FL, ML, PA, PFA, SM } from "../../../router/AddRoutesJson";
import DataStatusTable from "../../client-manager/DataStatusTable";
import useClientInfoList from "./../../../../components/hooks/useClientInfoList";
import AddNewClient from "./AddNewClient";
import { useParams } from "react-router-dom";
import FormLabel from "../../../../components/label/FormLabel";
import ClientListTable from "./../../client-manager/ClientListTable";
import { isProjectAdmin } from "./../../../../helpers/authFunctions";
import useInfraFormData from "../../../../components/hooks/useInfraFormData";
import { showSuccess } from "../../../../helpers/alerts";
import Loader from "../../../../components/spinner/Loader";
import useProjectInfoQuery from "../../../../components/hooks/useProjectInfoQuery";
import { RE_DIRECT_TO } from "../../../../helpers/redirectHelper";

const { SHOW_PARENT } = TreeSelect;

const transformClientDataToTree = (clientInfoList) => {
  return clientInfoList.map((client, index) => {
    return {
      title: `${client.clientName} (${client.region})`,
      value: `${client.record_id}`, // Use client.record_id here
      key: `${client.record_id}`,
      children: [
        {
          title: `Client Manager: ${client.clientManager}`,
          value: `client-${index}-manager`,
          checkable: false,
          key: `client-${index}-manager`,
          children: client.siteManager.map((manager, idx) => ({
            title: `Site: ${manager.siteName}`,
            value: `client-${index}-manager-${idx}`,
            key: `client-${index}-manager-${idx}`,
            checkable: false,
          })),
        },
      ],
    };
  });
};

const TreeSelectTry = () => {
  const [form] = Form.useForm();
  const { data: clientInfoList, error, isLoading } = useClientInfoList();
  const [isCreationDone, setIsCreationDone] = useState(false);
  const { id } = useParams();
  const { data: projectInfoData } = useProjectInfoQuery(id, getProjectInfoById);
  // const {
  //   data: infraFormData,
  //   error: infraFormError,
  //   isLoading: infraFormLoading,
  // } = useInfraFormData(id);
  const {
    data: assignedClientList,
    error: assignedClientListError,
    isLoading: assignedClientListIsLoading,
  } = useQuery({
    queryKey: ["assignedClientListKey_"],
    queryFn: getAssignClientList,
  });

  const treeData = clientInfoList
    ? transformClientDataToTree(clientInfoList)
    : [];

  const tProps = {
    treeData,
    treeCheckable: true,
    showCheckedStrategy: SHOW_PARENT,
    placeholder: "Please select",
    style: {
      width: "100%",
    },
    showSearch: true,
    filterTreeNode: (inputValue, treeNode) =>
      treeNode.title.toLowerCase().includes(inputValue.toLowerCase()),
  };

  useEffect(() => {
    if (id && clientInfoList && assignedClientList) {
      form.setFieldsValue({
        treeSelect: assignedClientList.map((item) => item.clientId).flat(),
      });
    }
  }, [clientInfoList, assignedClientList, form]);

  const assignClientMutation = useMutation({
    mutationFn: assignClient,
    onSuccess: (data) => {
      if (data.statusCode === 200) {
        showSuccess("Clients assigned successfully!");
        RE_DIRECT_TO("/fl-project");
        if (!id) {
          setIsCreationDone(true);
        }
      }
    },
  });
  const backendEntryAssignClientMutation = useMutation({
    mutationFn: backendEntryAssignClient,
    onSuccess: (data) => {
      if (data.statusCode === 200) {
        // showSuccess("Clients mapped successfully!");
        if (!id) {
          setIsCreationDone(true);
        }
      }
    },
  });

  const updateAssignClientMutation = useMutation({
    mutationFn: updateAssignClient,
    onSuccess: (data) => {
      if (data.statusCode === 200) {
        showSuccess("Clients Updated successfully!");
      }
    },
  });

  const onFinish = (values) => {
    const recordIds = values.treeSelect;
    const filteredData = clientInfoList?.filter((item) =>
      recordIds.includes(item.record_id)
    );
    // console.log(filteredData);

    if (filteredData?.length > 0) {
      // backendEntryAssignClient
      backendEntryAssignClientMutation.mutate(filteredData);
    }
    if (assignedClientList.length === 0) {
      assignClientMutation.mutate({
        treeValue: values.treeSelect,
        filteredData: filteredData,
      });
    } else {
      updateAssignClientMutation.mutate({
        treeValue: values.treeSelect,
        record_id: assignedClientList[0].record_id,
        filteredData: filteredData,
      });
    }
  };
  const onlyEnableProjectAdmin = !isProjectAdmin();
  return (
    <div className={onlyEnableProjectAdmin && "disableAll"}>
      {/* {JSON.stringify(projectInfoData)} */}
      {/* {JSON.stringify(assignedClientList)} */}
      {/* {JSON.stringify(assignedClientList)}=== //{" "}
      {JSON.stringify(clientInfoList)} */}
      {/* {assignedClientList?.length ? "pass" : "fail"} */}
      <AccessTo role={[PFA, PA]}>
        {!getProjectId() && (
          <Alert
            message="NOTE"
            className="mb-4"
            description="Before assigning, please complete the project info section!"
            type="warning"
            showIcon
          />
        )}
      </AccessTo>
      {/* <AccessTo role={[SM]}>
        <ClientListTable
          clientInfoList={clientInfoList}
          assignedClientList={assignedClientList}
        />
      </AccessTo> */}
      {/* <AccessTo role={[PFA, CM, FL, SM, ML]}>
        <DataStatusTable />
      </AccessTo> */}
      <AccessTo role={[PA]}>
        <div className="flex justify-end">
          <AddNewClient />
        </div>
      </AccessTo>
      <AccessTo role={[PA, FL]}>
        <Form
          form={form}
          name="tree_select_form"
          onFinish={onFinish}
          layout="vertical"
          requiredMark={false}
        >
          <Form.Item
            name="treeSelect"
            label={<FormLabel> Assign Clients</FormLabel>}
            rules={[{ required: true, message: "Please select a client!" }]}
          >
            <TreeSelect
              {...tProps}
              loading={isLoading || assignedClientListIsLoading}
              disabled={isLoading || onlyEnableProjectAdmin}
            />
          </Form.Item>
          {projectInfoData?.projectStatus == "Ready to Train" ||
          projectInfoData?.projectStatus == "Completed" ? (
            ""
          ) : (
            <AccessTo role={[PA]}>
              <div className="flex justify-center">
                <button
                  disabled={isCreationDone || !getProjectId()}
                  type="submit"
                  className="py-2 px-5 rounded text-white text-xs w-[300px] flex items-center justify-center bg-[#0057B8]"
                >
                  <Loader
                    isLoading={
                      updateAssignClientMutation.isPending ||
                      assignClientMutation.isPending
                    }
                  />
                  {assignedClientList?.length === 0 || !id
                    ? "Assign Client"
                    : "Update"}
                </button>
              </div>
            </AccessTo>
          )}
        </Form>
      </AccessTo>
    </div>
  );
};

export default TreeSelectTry;
